<template>
  <div id="app" :style="{ backgroundImage: `url(${bgImg_com})` }">
    <router-view />
  </div>
</template>

<script>
import storage from "@/utils/storage";
import defaultHomeBg from "@/assets/images/common/homeBg.png";

export default {
  data() {
    return {
      heartTimer: null,
      bgImg: "",
    };
  },

  computed: {
    bgImg_com() {
      // 判断当前路径（注意，这里不能实时更新$router.path）
      const nowPath = this.$route.path;
      // return
      try {
        if (nowPath.indexOf("login") >= 0) {
          return this.$store.getters.sysLoginBackground || defaultHomeBg;
        } else {
          return this.$store.getters.sysHomeBackground || defaultHomeBg;
        }
      } catch (err) {
        console.error("err", err);
        return defaultHomeBg;
      }
    },
  },
  mounted() {
    const timerName = this.$store.state.heartTimer;
    let token = storage.get("token");
    if (!timerName && token) {
      let localTimer = storage.get("heartTimer");
      if (localTimer) {
        storage.remove("heartTimer");
      }
      this.$store.commit("setHeartBeat");
    }

    const nowPath = this.$route.path;
    try {
      if (nowPath.indexOf("login") >= 0) {
        this.bgImg = this.$store.getters.sysLoginBackground || defaultHomeBg;
      } else {
        this.bgImg = this.$store.getters.sysHomeBackground || defaultHomeBg;
      }
    } catch(err) {
      console.error('err', err);
      this.bgImg = defaultHomeBg;
    }
    
    // console.log("$store", this.$store.getters);
    // console.log("$store: ", this.$store.getters.sysHostType);
    if(!document.title) document.title = this.$store.getters.sysPlatformName; // 修改名字
  },
};
</script>

<style lang="stylus">
@import '~@/assets/css/base'
</style>
